import { Button } from "@material-ui/core";
import tinyColor from "tinycolor2";
import styled from "../../../../config/emotion";

export const ColorPickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 1em;
`;

export const ColorPickerFooter = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  width: 100%;
`;

export const ChoseButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "selectColor",
})<{ selectColor: string }>`
  background: ${({ selectColor }) => selectColor};
  color: ${({ selectColor }) =>
    tinyColor(selectColor).isLight() ? "black" : "white"};
  margin-right: 10px;
`;
